import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Components
import StaticBoard from "../components/StaticBoard";
import ScoreFunction from "../components/ScoreFunction"
import instructionSheets from "../data/instructionSheets.js";
import VboardStates from "../data/VboardStates.js";
import Button from "../components/Button";

class Feedback extends Component {


  render() {
	
	const userFinalStateBoard = this.props.userSteps[this.props.lastStepIdx]["board_state"]
	const imageId = instructionSheets[this.props.taskUserId]["image_index"]
	
	return (
	<GridLayout>
      <InstructionContainer>
          <h2>Score</h2>
		  <P>
			 The drawing procedure index you selected is: <b>{this.props.taskUserId} </b>  
			<br/><br/>Your Execution Score is: &nbsp; 
			<b> 
			{(this.props.lastStepIdx===0)?  "No Score" : ScoreFunction(VboardStates[imageId],userFinalStateBoard)} 			
			 </b>
			
			 
			<br/>This score measures how well you reconstructed the target image. 
			<br/><br/>  Click the Try Again button for giving it another try or for selecting a new drawing procedure. 
			<br/> You may check the intended execution for this task in the  
			<a style ={{padding: "3px"}} href="https://nlp.biu.ac.il/~royi/hexagon-paper-visualization/#/main" target="_blank">
				Data Visualization
			</a>			
			(insert the index above). 
			<br/> <br/> 
			<StyledButton> 
			<RedirectLink to="/login">
			Try Again
			</RedirectLink>
			
			</StyledButton>
			
			</P>
		  
		</InstructionContainer>      	 
       	
		
		
		
				
	</GridLayout>	
      
    );
  }
}

export default Feedback;

const GridLayout = styled.div`
display: grid ;
grid-template-columns: 50% 50%;
grid-template-areas:
    "instruction instruction"
	"user original"
	"button button";
`;


const InstructionContainer = styled.div`
background: lightblue;
margin: 3em;
width: 90vw;
grid-area: instruction;

`;
 
const P = styled.p`
text-align: left;
font-size: large;
margin: 1em;
`;

const ElementContainer = styled.div`
  margin: 1em 2em; // that makes some space bewtween the containers so they are not tight to each other
 background-color: white;
  width: 45vw;
  max-height: 75vh;
  
`;


const OriginalBoardContainer = styled(ElementContainer)`
display: inline-block;
align-items: center;
grid-area: original;



`;

const UserBoardContainer = styled(ElementContainer)`
display: inline-block;
align-items: center;
grid-area: user;


`;



const StyledButton = styled(Button)`
  width: 15%;
  margin-left: 45% ;
`;



const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align:center;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  #background: red;

  transition: all 300ms;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;							